export default __webpack_public_path__ + "static/media/insular-mobile.fa429ee5.png";